import { render, staticRenderFns } from "./TaxiList.vue?vue&type=template&id=2ad42a12&scoped=true"
import script from "./TaxiList.vue?vue&type=script&lang=js"
export * from "./TaxiList.vue?vue&type=script&lang=js"
import style0 from "./TaxiList.vue?vue&type=style&index=0&id=2ad42a12&prod&lang=scss&scoped=true"
import style1 from "./TaxiList.vue?vue&type=style&index=1&id=2ad42a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad42a12",
  null
  
)

export default component.exports